import { z } from 'zod'

export const resetPasswordSchema = z.object({
  newPassword: z.string().min(6, 'Please enter a password of at least 6 characters').regex(new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$"),"Password must be contains at least one uppercase letter, one lowercase letter, one number and one special character")
})

export type ResetPasswordSchemaInput = z.TypeOf<typeof resetPasswordSchema>
